import React, { useState, useEffect } from "react";
import {
  getPlayersRelatedToTeam,
  getCombinedSenseData,
} from "../config/mainRequest";
import { parseSenseVectorTree } from "../utils/parseSenseVectorTree";
import { specialEventsMap } from "../common/abbr";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Chip,
  Collapse,
  TextField,
  InputAdornment,
  CircularProgress,
  Button,
} from "@mui/material";
import { FixedSizeList } from "react-window";
import {
  ExpandMore,
  ChevronRight,
  PlayArrow,
  AccessTime,
  FolderOpen,
  AccountTree,
  ViewList,
  SearchOutlined,
  Folder,
  SportsSoccer,
  ContentCopy,
  Check,
  Replay5,
  Replay10,
  Forward5,
  Forward10,
} from "@mui/icons-material";
import ReactPlayer from "react-player";

// ─── Event Tree Data (dummy) ───
// TODO: API — fetch categorized events for this match
const DUMMY_TREE = [
  {
    label: "Passing", children: [
      { label: "Short Pass", children: [
        { label: "Unsuccessful", count: 26, events: [
          { jersey: 10, name: "Müller", time: "05:12", str: "A-10-SP-0-22-X-0:05:12-R-X-FHN-X-X" },
          { jersey: 7, name: "Gnabry", time: "12:30", str: "A-7-SP-0-35-X-0:12:30-R-X-FHN-X-X" },
          { jersey: 8, name: "Goretzka", time: "23:44", str: "A-8-SP-0-41-X-0:23:44-L-X-FHN-X-X" },
        ]},
        { label: "Simple Pass", count: 134, events: [
          { jersey: 6, name: "Kimmich", time: "01:15", str: "A-6-SP-1-30-40-0:01:15-R-X-FHN-X-X" },
          { jersey: 42, name: "Musiala", time: "03:22", str: "A-42-SP-1-45-50-0:03:22-R-X-FHN-X-X" },
          { jersey: 19, name: "Davies", time: "07:08", str: "A-19-SP-1-12-20-0:07:08-L-X-FHN-X-X" },
        ]},
        { label: "Key Pass", count: 4, events: [
          { jersey: 42, name: "Musiala", time: "34:20", str: "A-42-SP-2-50-60-0:34:20-R-X-FHN-X-X" },
        ]},
        { label: "Assist", count: 0, events: [] },
      ]},
      { label: "Long Pass", children: [
        { label: "Unsuccessful", count: 21, events: [
          { jersey: 2, name: "Upamecano", time: "08:11", str: "A-2-LP-0-15-55-0:08:11-R-X-FHN-X-X" },
        ]},
        { label: "Simple Pass", count: 35, events: [
          { jersey: 6, name: "Kimmich", time: "11:03", str: "A-6-LP-1-25-65-0:11:03-R-X-FHN-X-X" },
        ]},
        { label: "Key Pass", count: 1, events: [] },
        { label: "Assist", count: 1, events: [
          { jersey: 42, name: "Musiala", time: "67:30", str: "A-42-LP-3-40-70-1:07:30-R-X-SHN-X-X" },
        ]},
      ]},
      { label: "Through Ball", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Simple Pass", count: 0, events: [] },
        { label: "Key Pass", count: 0, events: [] },
        { label: "Assist", count: 0, events: [] },
      ]},
      { label: "Cross", children: [
        { label: "Unsuccessful", count: 8, events: [
          { jersey: 10, name: "Sané", time: "15:22", str: "A-10-C-0-10-60-0:15:22-L-X-FHN-X-X" },
          { jersey: 7, name: "Gnabry", time: "41:05", str: "A-7-C-0-12-58-0:41:05-R-X-FHN-X-X" },
        ]},
        { label: "Simple Pass", count: 7, events: [
          { jersey: 19, name: "Davies", time: "28:40", str: "A-19-C-1-8-55-0:28:40-L-X-FHN-X-X" },
        ]},
        { label: "Key Pass", count: 3, events: [] },
        { label: "Assist", count: 1, events: [
          { jersey: 10, name: "Sané", time: "72:18", str: "A-10-C-3-10-62-1:12:18-L-X-SHN-X-X" },
        ]},
      ]},
    ],
  },
  {
    label: "Shooting", children: [
      { label: "Long Shot", children: [
        { label: "Off Target", count: 5, events: [
          { jersey: 42, name: "Musiala", time: "18:50", str: "A-42-LS-0-45-70-0:18:50-R-X-FHN-X-X" },
          { jersey: 8, name: "Goretzka", time: "55:12", str: "A-8-LS-0-40-68-0:55:12-R-X-SHN-X-X" },
        ]},
        { label: "Simple Shot", count: 2, events: [
          { jersey: 25, name: "Müller", time: "33:10", str: "A-25-LS-1-42-72-0:33:10-R-X-FHN-X-X" },
        ]},
        { label: "Hit Goal Post", count: 0, events: [] },
        { label: "Brilliant Shot", count: 0, events: [] },
        { label: "Goal", count: 0, events: [] },
      ]},
      { label: "Close Shot", children: [
        { label: "Off Target", count: 1, events: [
          { jersey: 7, name: "Gnabry", time: "61:20", str: "A-7-CS-0-68-75-1:01:20-R-X-SHN-X-X" },
        ]},
        { label: "Simple Shot", count: 2, events: [] },
        { label: "Hit Goal Post", count: 0, events: [] },
        { label: "Brilliant Shot", count: 0, events: [] },
        { label: "Goal", count: 3, events: [
          { jersey: 10, name: "Sané", time: "45:00", str: "A-10-CS-4-70-78-0:45:00-L-X-FHN-X-X" },
          { jersey: 42, name: "Musiala", time: "72:30", str: "A-42-CS-4-72-76-1:12:30-R-X-SHN-X-X" },
          { jersey: 25, name: "Müller", time: "89:15", str: "A-25-CS-4-74-77-1:29:15-R-X-SHN-X-X" },
        ]},
      ]},
    ],
  },
  {
    label: "Defending", children: [
      { label: "Interceptions", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Successful", count: 15, events: [
          { jersey: 6, name: "Kimmich", time: "09:30", str: "A-6-IN-1-35-X-0:09:30-R-X-FHN-X-X" },
          { jersey: 3, name: "Kim", time: "21:55", str: "A-3-IN-1-28-X-0:21:55-R-X-FHN-X-X" },
        ]},
        { label: "Crucial", count: 5, events: [
          { jersey: 2, name: "Upamecano", time: "38:12", str: "A-2-IN-2-18-X-0:38:12-R-X-FHN-X-X" },
        ]},
      ]},
      { label: "Clearances", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Successful", count: 51, events: [
          { jersey: 2, name: "Upamecano", time: "14:20", str: "A-2-CL-1-12-X-0:14:20-R-X-FHN-X-X" },
        ]},
        { label: "Crucial", count: 20, events: [] },
        { label: "Goal Line Clearance", count: 0, events: [] },
      ]},
      { label: "Standing Tackles", children: [
        { label: "Unsuccessful", count: 1, events: [
          { jersey: 19, name: "Davies", time: "20:41", str: "A-19-ST-0-22-X-0:20:41-L-X-FHN-X-X" },
        ]},
        { label: "Successful", count: 5, events: [
          { jersey: 6, name: "Kimmich", time: "17:05", str: "A-6-ST-1-30-X-0:17:05-R-X-FHN-X-X" },
        ]},
        { label: "Crucial", count: 7, events: [] },
      ]},
      { label: "Sliding Tackles", children: [
        { label: "Unsuccessful", count: 1, events: [
          { jersey: 19, name: "Philip", time: "20:41", str: "A-19-SL-0-25-X-0:20:41-R-X-FHN-X-X" },
        ]},
        { label: "Successful", count: 1, events: [
          { jersey: 6, name: "Mike", time: "17:05", str: "A-6-SL-1-32-X-0:17:05-R-X-FHN-X-X" },
        ]},
        { label: "Crucial", count: 0, events: [] },
      ]},
      { label: "Pressing", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Successful", count: 0, events: [] },
        { label: "Crucial", count: 0, events: [] },
      ]},
    ],
  },
  {
    label: "Physical", children: [
      { label: "Aerial Duels", children: [
        { label: "Duel Lost", count: 5, events: [
          { jersey: 6, name: "Mike", time: "14:31", str: "A-6-AD-0-40-X-0:14:31-R-X-FHN-X-X" },
          { jersey: 11, name: "Louis", time: "00:03", str: "A-11-AD-0-50-X-0:00:03-R-X-FHN-X-X" },
          { jersey: 7, name: "Steve", time: "87:50", str: "A-7-AD-0-55-X-1:27:50-R-X-SHN-X-X" },
          { jersey: 21, name: "Zack", time: "77:15", str: "A-21-AD-0-48-X-1:17:15-R-X-SHN-X-X" },
          { jersey: 21, name: "Zack", time: "78:33", str: "A-21-AD-0-52-X-1:18:33-R-X-SHN-X-X" },
        ]},
        { label: "Duel Won", count: 0, events: [] },
      ]},
      { label: "Ground Duels", children: [
        { label: "Duel Lost", count: 19, events: [
          { jersey: 42, name: "Musiala", time: "22:10", str: "A-42-GD-0-38-X-0:22:10-R-X-FHN-X-X" },
        ]},
        { label: "Duel Won", count: 4, events: [] },
      ]},
      { label: "Headers Won", children: [
        { label: "Off Target", count: 1, events: [] },
        { label: "Simple Header", count: 2, events: [] },
        { label: "Hit Goal Post", count: 0, events: [] },
        { label: "Brilliant Header", count: 0, events: [] },
        { label: "Goal", count: 0, events: [] },
      ]},
    ],
  },
  {
    label: "Dribbling", children: [
      { label: "Dribbling", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Successful", count: 3, events: [
          { jersey: 42, name: "Musiala", time: "30:15", str: "A-42-DR-1-45-50-0:30:15-R-X-FHN-X-X" },
        ]},
        { label: "Crucial", count: 1, events: [] },
      ]},
      { label: "Difficult Recieves", children: [
        { label: "Unsuccessful", count: 36, events: [
          { jersey: 7, name: "Gnabry", time: "52:40", str: "A-7-DC-0-55-X-0:52:40-R-X-SHN-X-X" },
        ]},
        { label: "Successful", count: 0, events: [] },
      ]},
    ],
  },
  {
    label: "Ball Carry", children: [
      { label: "Ball Carry", children: [
        { label: "Ball Carry Short", count: 30, events: [
          { jersey: 6, name: "Kimmich", time: "04:22", str: "A-6-DR-1-30-35-0:04:22-R-X-FHN-X-X" },
        ]},
        { label: "Ball Carry Medium", count: 9, events: [] },
        { label: "Ball Carry Long", count: 1, events: [] },
      ]},
    ],
  },
  {
    label: "Goalkeeping", children: [
      { label: "Saves", children: [
        { label: "Goal Conceded", count: 1, events: [
          { jersey: 1, name: "Neuer", time: "58:20", str: "A-1-GS-0-5-X-0:58:20-R-X-SHN-X-X" },
        ]},
        { label: "Simple Shot Saved", count: 6, events: [
          { jersey: 1, name: "Neuer", time: "16:44", str: "A-1-GS-1-4-X-0:16:44-R-X-FHN-X-X" },
        ]},
        { label: "Key Shot Saved", count: 0, events: [] },
        { label: "Brilliant Shot Saved", count: 0, events: [] },
      ]},
      { label: "Handling", children: [
        { label: "Unsuccessful", count: 0, events: [] },
        { label: "Loose Ball Handled", count: 14, events: [
          { jersey: 1, name: "Neuer", time: "25:10", str: "A-1-GH-1-6-X-0:25:10-R-X-FHN-X-X" },
        ]},
        { label: "Key Ball Handled", count: 0, events: [] },
      ]},
      { label: "Goalkeeper Throw", children: [
        { label: "Unsuccessful", count: 9, events: [] },
        { label: "Simple Throw", count: 10, events: [
          { jersey: 1, name: "Neuer", time: "31:00", str: "A-1-GT-1-5-20-0:31:00-R-X-FHN-X-X" },
        ]},
        { label: "Key Throw", count: 0, events: [] },
      ]},
    ],
  },
  {
    label: "Special Actions", children: [
      { label: "Handball", children: [
        { label: "Handball", count: 1, events: [
          { jersey: 8, name: "Goretzka", time: "40:10", str: "A-8-HB-1-42-X-0:40:10-R-X-FHN-X-X" },
        ]},
      ]},
      { label: "Offside", children: [
        { label: "Offside", count: 1, events: [
          { jersey: 20, name: "Peter", time: "25:35", str: "A-20-OFF-1-65-X-0:25:35-R-X-FHN-X-X" },
        ]},
      ]},
      { label: "Throw", children: [
        { label: "Unsuccessful", count: 5, events: [] },
        { label: "Simple Throw", count: 11, events: [
          { jersey: 19, name: "Davies", time: "13:45", str: "A-19-THW-1-1-15-0:13:45-L-X-FHN-X-X" },
        ]},
        { label: "Key Throw", count: 0, events: [] },
        { label: "Assist Throw", count: 0, events: [] },
      ]},
    ],
  },
  {
    label: "Passing Actions Receive Attempts", children: [
      { label: "Short Pass Receive Attempts", children: [
        { label: "Received Unsuccessful", count: 24, events: [] },
        { label: "Received Simple Pass", count: 132, events: [
          { jersey: 42, name: "Musiala", time: "02:10", str: "A-42-SP-1-50-45-0:02:10-R-X-FHN-X-X" },
        ]},
        { label: "Received Key Pass", count: 4, events: [] },
        { label: "Received Assist", count: 0, events: [] },
      ]},
      { label: "Long Pass Receive Attempts", children: [
        { label: "Received Unsuccessful", count: 18, events: [] },
        { label: "Received Simple Pass", count: 30, events: [] },
        { label: "Received Key Pass", count: 2, events: [] },
        { label: "Received Assist", count: 1, events: [] },
      ]},
    ],
  },
];

const getTotalCount = (node) => {
  if (node.events) return node.count || 0;
  if (node.children) return node.children.reduce((sum, c) => sum + getTotalCount(c), 0);
  return 0;
};

// ─── Tree Node Component ───
// Per-team accent colors for the play icon / hover (Team A = blue, B = orange).
const TEAM_COLORS = {
  A: { rgb: "59, 130, 246" },
  B: { rgb: "232, 108, 0" },
};

const TreeNode = React.memo(({ node, depth, onSelectEvent, selectedEvent, path = [], expandedSet, onToggle, activeTreeEventRef, teamAName, teamBName }) => {
  const currentPath = [...path, node.label];
  const pathKey = currentPath.join("/");
  const open = expandedSet.has(pathKey);
  const isLeaf = !node.children;
  const hasEvents = isLeaf && node.events && node.events.length > 0;
  const count = isLeaf ? (node.count || 0) : getTotalCount(node);
  const isEmpty = count === 0;

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        onClick={() => (!isLeaf || hasEvents) && onToggle(pathKey)}
        sx={{
          pl: depth * 2.5,
          pr: 1,
          py: 0.6,
          cursor: (isLeaf && !hasEvents) ? "default" : "pointer",
          "&:hover": {
            backgroundColor: (isLeaf && !hasEvents) ? "transparent" : "var(--surface-2)",
          },
          borderRadius: "4px",
          transition: "background-color 0.1s",
        }}
      >
        {isLeaf ? (
          hasEvents ? (
            open ? <ExpandMore sx={{ fontSize: 18, color: "var(--text-2)", mr: 0.5 }} />
                 : <ChevronRight sx={{ fontSize: 18, color: "var(--text-2)", mr: 0.5 }} />
          ) : <Box sx={{ width: 22, mr: 0.5 }} />
        ) : (
          open ? <ExpandMore sx={{ fontSize: 18, color: "var(--text-2)", mr: 0.5 }} />
               : <ChevronRight sx={{ fontSize: 18, color: "var(--text-2)", mr: 0.5 }} />
        )}

        {isLeaf
          ? <Folder sx={{ fontSize: 16, color: isEmpty ? "var(--text-2)" : "rgba(232, 108, 0, 0.7)", mr: 0.75, opacity: isEmpty ? 0.4 : 1 }} />
          : <FolderOpen sx={{ fontSize: 16, color: "var(--text-2)", mr: 0.75 }} />
        }

        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: isLeaf ? 400 : 600,
            color: isEmpty && isLeaf ? "var(--text-2)" : "var(--text-1)",
            opacity: isEmpty && isLeaf ? 0.5 : 1,
            flex: 1,
          }}
        >
          {node.label}
        </Typography>

        {count > 0 && (
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              color: isLeaf ? "rgba(232, 108, 0, 1)" : "var(--text-2)",
              ml: 0.5,
            }}
          >
            ({count})
          </Typography>
        )}
      </Stack>

      {/* Children or events */}
      <Collapse in={open} mountOnEnter unmountOnExit>
        {!isLeaf && node.children?.map((child, i) => (
          <TreeNode
            key={`${child.label}-${i}`}
            node={child}
            depth={depth + 1}
            onSelectEvent={onSelectEvent}
            selectedEvent={selectedEvent}
            path={currentPath}
            expandedSet={expandedSet}
            onToggle={onToggle}
            activeTreeEventRef={activeTreeEventRef}
            teamAName={teamAName}
            teamBName={teamBName}
          />
        ))}
        {isLeaf && hasEvents && [...node.events]
          .sort((a, b) => parseTimeToSeconds(a.time) - parseTimeToSeconds(b.time))
          .map((evt, i) => {
          const isEvtActive = selectedEvent?.str === evt.str;
          const teamKey = (evt.str || "").split("-")[0] === "B" ? "B" : "A";
          const teamName = teamKey === "B" ? teamBName : teamAName;
          const rgb = (TEAM_COLORS[teamKey] || TEAM_COLORS.A).rgb;
          return (
          <Stack
            key={i}
            ref={isEvtActive ? activeTreeEventRef : undefined}
            direction="row"
            alignItems="center"
            onClick={() => onSelectEvent({ ...evt, path: currentPath })}
            sx={{
              pl: (depth + 1) * 2.5,
              pr: 1,
              py: 0.75,
              cursor: "pointer",
              borderRadius: "4px",
              backgroundColor: isEvtActive ? `rgba(${rgb}, 0.1)` : "transparent",
              "&:hover": { backgroundColor: `rgba(${rgb}, 0.08)` },
              transition: "background-color 0.1s",
              gap: 1,
              // Offscreen rows skip layout/paint — keeps long lists scrolling at 60fps.
              contentVisibility: "auto",
              containIntrinsicSize: "0 34px",
            }}
          >
            <PlayArrow sx={{ fontSize: 16, color: `rgba(${rgb}, 1)` }} />
            <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "var(--text-1)" }}>
              {evt.jersey}. {evt.name}{teamName ? ` (${teamName})` : ""}
            </Typography>
            <Stack sx={{ ml: "auto", alignItems: "flex-end", gap: 0.25 }}>
              <Chip
                icon={<AccessTime sx={{ fontSize: "12px !important" }} />}
                label={evt.time}
                size="small"
                sx={{
                  height: 22,
                  fontSize: "11px",
                  fontWeight: 600,
                  backgroundColor: "var(--surface-2)",
                  color: "var(--text-2)",
                  border: "1px solid var(--border-1)",
                  "& .MuiChip-icon": { color: "var(--text-2)" },
                }}
              />
              {/* {evt.matchVideo && (
                <Typography sx={{ fontSize: "9px", color: "var(--text-2)", lineHeight: 1 }}>
                  MV {evt.matchVideo}
                </Typography>
              )} */}
            </Stack>
          </Stack>
          );
        })}
      </Collapse>
    </Box>
  );
});

// ─── Main Spotlight Component ───
// Flat list straight from the match_string — one row per comma-separated token
// (12-field: Team-Jersey-Code-EventId-Start-End-Time-... ; time is field 6).
const EMPTY_MATCH_TOKEN = "X-X-X-X-X-X-X-X-X-X-X-X";
const parseMatchStringFlat = (matchString, resolveName) =>
  String(matchString || "")
    .split(",")
    .map((s) => s.trim())
    .filter((t) => t && t !== EMPTY_MATCH_TOKEN)
    .map((tok) => {
      const f = tok.split("-");
      const jersey = f[1];
      const time = f[6] && f[6] !== "X" ? f[6] : "";
      return {
        str: tok,
        time,
        jersey: jersey === "X" ? "" : jersey,
        name: (resolveName && resolveName(f[0], jersey)) || "",
      };
    });

// "Top Events" = events flagged with a special_event (token field 8) from
// specialEventsMap, excluding "None" (X); "Pass & Go" only when touches enabled.
const topEventCodeSet = (enableTouches) =>
  new Set(
    Object.keys(specialEventsMap).filter(
      (code) =>
        code !== "X" && (enableTouches || specialEventsMap[code] !== "Pass & Go")
    )
  );
// `topCodes` = Set of allowed special_event codes, or null to skip the filter.
const eventInScope = (evt, teamFilter, topCodes) => {
  const f = (evt.str || "").split("-");
  if (teamFilter !== "all" && f[0] !== teamFilter) return false;
  if (topCodes && !topCodes.has(f[8])) return false;
  return true;
};
// Keep only leaf events matching `keep`, dropping empty branches.
const pruneTree = (nodes, keep) =>
  nodes.reduce((acc, node) => {
    if (node.events) {
      const evs = node.events.filter(keep);
      if (evs.length) acc.push({ ...node, events: evs, count: evs.length });
    } else if (node.children) {
      const kids = pruneTree(node.children, keep);
      if (kids.length) acc.push({ ...node, children: kids });
    }
    return acc;
  }, []);

const flattenEvents = (nodes, path = []) => {
  const result = [];
  for (const node of nodes) {
    const currentPath = [...path, node.label];
    if (node.events) {
      for (const evt of node.events) {
        result.push({ ...evt, path: currentPath, category: currentPath[0] || "", action: currentPath.slice(1).join(" › "), leaf: node.label });
      }
    }
    if (node.children) {
      result.push(...flattenEvents(node.children, currentPath));
    }
  }
  return result;
};

const parseTimeToSeconds = (t) => {
  const parts = t.split(":").map(Number);
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  return 0;
};

// Under the Goalkeeping category, keep only these sub-attributes.
const GK_CATEGORY = "Goalkeeping";
const GK_ALLOWED_SUBS = new Set(["Goalkeeper Throw", "Handling", "Saves"]);
const pruneGoalkeeping = (nodes) =>
  nodes.map((node) =>
    node.label === GK_CATEGORY && node.children
      ? { ...node, children: node.children.filter((c) => GK_ALLOWED_SUBS.has(c.label)) }
      : node
  );

// Directory for the "Top Events" filter: one category per special_event type
// (Goal, Corner, Foul, …), holding the matching events sorted by time.
// Outcome label → special_event code (e.g. "Goal" → "G"). Mirrors TMS, where a
// Goal is identified by its action alias, not the special_event token — a shot
// whose outcome is "Goal" is a top Goal event even without the "G" flag.
const NAME_TO_CODE = Object.fromEntries(
  Object.entries(specialEventsMap)
    .filter(([code]) => code !== "X")
    .map(([code, name]) => [name, code])
);

const buildTopEventsTree = (tree, teamFilter, topCodes) => {
  const byCode = {};
  const seen = {}; // code → Set(event key) to dedupe token- vs alias-matched hits
  const add = (code, e, key) => {
    if (!code || !topCodes.has(code)) return;
    const set = (seen[code] = seen[code] || new Set());
    if (set.has(key)) return;
    set.add(key);
    (byCode[code] = byCode[code] || []).push(e);
  };
  flattenEvents(tree).forEach((e) => {
    const f = (e.str || "").split("-");
    if (teamFilter !== "all" && f[0] !== teamFilter) return;
    const key = e.str || `${e.name}-${e.time}`;
    add(f[8], e, key); // special_event token
    add(NAME_TO_CODE[e.leaf], e, key); // alias/outcome (Goal, Own Goal, …)
  });
  return Object.keys(specialEventsMap)
    .filter((code) => byCode[code]?.length)
    .map((code) => ({
      label: specialEventsMap[code],
      count: byCode[code].length,
      events: byCode[code].sort(
        (a, b) => parseTimeToSeconds(a.time) - parseTimeToSeconds(b.time)
      ),
    }));
};

const TimelineItem = React.memo(({ evt, isActive, onClick, style, teamAName, teamBName }) => {
  const teamKey = (evt.str || "").split("-")[0] === "B" ? "B" : "A";
  const teamName = teamKey === "B" ? teamBName : teamAName;
  const rgb = (TEAM_COLORS[teamKey] || TEAM_COLORS.A).rgb;
  return (
    <Stack
      style={style}
      direction="row"
      alignItems="center"
      onClick={onClick}
      sx={{
        px: 1.5,
        py: 0.75,
        gap: 1,
        cursor: "pointer",
        borderRadius: "6px",
        boxSizing: "border-box",
        backgroundColor: isActive ? `rgba(${rgb}, 0.1)` : "transparent",
        borderLeft: isActive ? `3px solid rgba(${rgb}, 1)` : "3px solid transparent",
        "&:hover": { backgroundColor: isActive ? `rgba(${rgb}, 0.12)` : `rgba(${rgb}, 0.04)` },
        borderBottom: "1px solid var(--border-1)",
        transition: "background-color 0.1s",
      }}
    >
      <Stack sx={{ flexShrink: 0, gap: 0.25 }}>
        <Chip
          icon={<AccessTime sx={{ fontSize: "11px !important" }} />}
          label={evt.time}
          size="small"
          sx={{
            height: 22,
            fontSize: "11px",
            fontWeight: 600,
            backgroundColor: isActive ? "rgba(232, 108, 0, 0.12)" : "var(--surface-2)",
            color: isActive ? "rgba(232, 108, 0, 1)" : "var(--text-1)",
            border: `1px solid ${isActive ? "rgba(232, 108, 0, 0.3)" : "var(--border-1)"}`,
            "& .MuiChip-icon": { color: isActive ? "rgba(232, 108, 0, 0.7)" : "var(--text-2)" },
            minWidth: 60,
          }}
        />
        {/* {evt.matchVideo && (
          <Typography sx={{ fontSize: "9px", color: "var(--text-2)", textAlign: "center", lineHeight: 1 }}>
            MV {evt.matchVideo}
          </Typography>
        )} */}
      </Stack>
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: "12px", fontWeight: isActive ? 700 : 600, color: isActive ? `rgba(${rgb}, 1)` : "var(--text-1)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          #{evt.jersey} {evt.name}{teamName ? ` (${teamName})` : ""}
        </Typography>
        <Typography sx={{ fontSize: "10px", color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {evt.path ? evt.path.join(" › ") : ""}
        </Typography>
      </Stack>
      <PlayArrow sx={{ fontSize: 16, color: isActive ? `rgba(${rgb}, 1)` : `rgba(${rgb}, 0.4)`, flexShrink: 0 }} />
    </Stack>
  );
});

const Spotlight = ({ matchId, match, token, organizerId }) => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [viewMode, setViewMode] = useState("spotlight");
  const [searchQuery, setSearchQuery] = useState("");
  const [teamFilter, setTeamFilter] = useState("all"); // "all" | "A" | "B"
  const [topEventsOnly, setTopEventsOnly] = useState(false);
  const [expandedPaths, setExpandedPaths] = useState(new Set());
  const [tree, setTree] = useState([]);
  // Flat event list built from the real match_string (matchById), used for the
  // Event Details "Events" list.
  const [matchStringEvents, setMatchStringEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const activeTreeEventRef = React.useRef(null);
  const treeScrollRef = React.useRef(null);
  const playerRef = React.useRef(null);
  // Virtualized timeline list plumbing.
  const timelineListRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const [listHeight, setListHeight] = useState(480);
  const TIMELINE_ROW_H = 56;

  // Track the available height for the virtualized list.
  useEffect(() => {
    const el = listBoxRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      const h = entries[0]?.contentRect?.height;
      if (h && Math.abs(h - listHeight) > 1) setListHeight(h);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [listHeight]);

  // Seek then start playback imperatively. `playing` is intentionally NOT a
  // controlled prop — the native controls own play/pause, which avoids the
  // play/pause loop that a controlled prop creates when the user clicks play.
  const seekToTime = React.useCallback((seconds) => {
    if (!playerRef.current || seconds == null || seconds < 0) return;
    try {
      playerRef.current.seekTo(seconds, "seconds");
      const internal = playerRef.current.getInternalPlayer?.();
      if (internal?.playVideo) internal.playVideo();      // YouTube
      else if (internal?.play) internal.play();           // HTML5 / file
    } catch (_) {}
  }, []);

  // Skip relative to the current position (± seconds).
  const skip = React.useCallback((delta) => {
    const p = playerRef.current;
    if (!p) return;
    const cur = p.getCurrentTime?.() || 0;
    seekToTime(Math.max(0, cur + delta));
  }, [seekToTime]);

  // Jump to an absolute "mm:ss" / "h:mm:ss" / seconds value.
  const [jumpValue, setJumpValue] = useState("");
  const jumpToTimestamp = React.useCallback(() => {
    const v = jumpValue.trim();
    if (!v) return;
    const secs = v.includes(":") ? parseTimeToSeconds(v) : Number(v);
    if (Number.isFinite(secs) && secs >= 0) seekToTime(secs);
  }, [jumpValue, seekToTime]);

  // Video URL from the match's youtube_videos (the one mapped to this match).
  const videoUrl = React.useMemo(() => {
    const vids = match?.youtube_videos || [];
    const mapped = vids.find(
      (v) => v?.matches?.some((m) => String(m) === String(matchId))
    );
    return mapped?.url || vids[0]?.url || null;
  }, [match, matchId]);

  // Fetch both squads (for player ids + name/team), then the combined Sense
  // vector_map, and build the category tree. Each vector's starting_video maps
  // to the video position for playback.
  useEffect(() => {
    if (!matchId || !token) return;
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const playedInMatch = [3, 6, 7, 8, 9].includes(Number(match?.status));
        const [teamA, teamB] = await Promise.all([
          match?.team_a_details?.id
            ? getPlayersRelatedToTeam({ teamId: match.team_a_details.id, matchId, organizerId, playedInMatch, token })
            : Promise.resolve([]),
          match?.team_b_details?.id
            ? getPlayersRelatedToTeam({ teamId: match.team_b_details.id, matchId, organizerId, playedInMatch, token })
            : Promise.resolve([]),
        ]);
        if (cancelled) return;

        // user_id → team notation / display name / jersey; team-jersey → name
        const teamByUserId = {};
        const nameByUserId = {};
        const jerseyByUserId = {};
        const nameByTeamJersey = {};
        const addSquad = (squad, notation) => {
          (squad || []).forEach((p) => {
            if (p?.id == null) return;
            teamByUserId[p.id] = notation;
            const nm = `${p.first_name || ""} ${p.last_name || ""}`.trim();
            nameByUserId[p.id] = nm;
            const jersey = p?.user_match_details?.jersey_number;
            if (jersey != null) {
              jerseyByUserId[p.id] = jersey;
              nameByTeamJersey[`${notation}-${jersey}`] = nm;
            }
          });
        };
        addSquad(teamA, "A");
        addSquad(teamB, "B");

        const idsA = (teamA || []).map((p) => p?.id).filter((id) => id != null);
        const idsB = (teamB || []).map((p) => p?.id).filter((id) => id != null);

        // One call per team (separate bulk_user_id lists).
        const [senseA, senseB] = await Promise.all([
          idsA.length ? getCombinedSenseData({ matchId, userIds: idsA, organizerId, token }) : Promise.resolve(null),
          idsB.length ? getCombinedSenseData({ matchId, userIds: idsB, organizerId, token }) : Promise.resolve(null),
        ]);
        if (cancelled) return;

        // Real event tokens come straight from the matchById response.
        const matchString = match?.match_sense_data?.match_sense?.match_string || "";

    
        const pickVm = (s) => s?.vector_map ?? s?.data?.vector_map ?? s ?? {};
        setTree(
          pruneGoalkeeping(
            parseSenseVectorTree([pickVm(senseA), pickVm(senseB)], { teamByUserId, nameByUserId, jerseyByUserId, matchString })
          )
        );
        // Flat event list from the real match_string for the Events detail list
        // (every comma-separated token, in order).
        const resolveName = (team, jersey) => nameByTeamJersey[`${team}-${jersey}`] || "";
        setMatchStringEvents(parseMatchStringFlat(matchString, resolveName));
      } catch (err) {
        console.error("[Spotlight] data fetch failed:", err?.message);
        if (!cancelled) { setTree([]); setMatchStringEvents([]); }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [matchId, token, match, organizerId]);

  // Tree scoped by the top filters (team + set pieces); search runs on top.
  // enable_touches comes from the selected organizer's details.
  const enableTouches = React.useMemo(() => {
    const org = (match?.organizer_details || []).find((o) => o.id === organizerId);
    return !!(org?.enable_touches ?? match?.enable_touches);
  }, [match, organizerId]);
  const topEventCodes = React.useMemo(() => topEventCodeSet(enableTouches), [enableTouches]);

  const scopedTree = React.useMemo(() => {


    // Top Events → regroup the directory by special_event type.
    if (topEventsOnly) return buildTopEventsTree(tree, teamFilter, topEventCodes);
    if (teamFilter === "all") return tree;
    return pruneTree(tree, (e) => eventInScope(e, teamFilter, null));
  }, [tree, teamFilter, topEventsOnly, topEventCodes]);

  const allEvents = React.useMemo(
    () => flattenEvents(scopedTree).sort((a, b) => parseTimeToSeconds(a.time) - parseTimeToSeconds(b.time)),
    [scopedTree]
  );

  // Debounced query keeps typing at 60fps while the heavy list re-filters.
  const [deferredQuery, setDeferredQuery] = useState(searchQuery);
  useEffect(() => {
    const t = setTimeout(() => setDeferredQuery(searchQuery), 150);
    return () => clearTimeout(t);
  }, [searchQuery]);

  const filteredTimeline = React.useMemo(() => {
    if (!deferredQuery.trim()) return allEvents;
    const q = deferredQuery.toLowerCase();
    return allEvents.filter(
      (e) =>
        e.name.toLowerCase().includes(q) ||
        String(e.jersey).includes(q) ||
        e.time.includes(q) ||
        (e.path && e.path.some((p) => p.toLowerCase().includes(q))) ||
        e.str.toLowerCase().includes(q)
    );
  }, [allEvents, deferredQuery]);

  const filterTree = React.useCallback((nodes, q) => {
    if (!q) return nodes;
    return nodes.reduce((acc, node) => {
      const selfMatch = node.label.toLowerCase().includes(q);

      if (selfMatch) {
        acc.push(node);
      } else if (node.events) {
        const filtered = node.events.filter(
          (e) =>
            e.name.toLowerCase().includes(q) ||
            String(e.jersey).includes(q) ||
            e.time.includes(q) ||
            e.str.toLowerCase().includes(q)
        );
        if (filtered.length > 0) {
          acc.push({ ...node, events: filtered, count: filtered.length });
        }
      } else if (node.children) {
        const filteredChildren = filterTree(node.children, q);
        if (filteredChildren.length > 0) {
          acc.push({ ...node, children: filteredChildren });
        }
      }
      return acc;
    }, []);
  }, []);

  const filteredTree = React.useMemo(() => {
    if (!deferredQuery.trim()) return scopedTree;
    return filterTree(scopedTree, deferredQuery.toLowerCase());
  }, [deferredQuery, filterTree, scopedTree]);

  const togglePath = React.useCallback((pathKey) => {
    setExpandedPaths(prev => {
      const next = new Set(prev);
      if (next.has(pathKey)) next.delete(pathKey); else next.add(pathKey);
      return next;
    });
  }, []);

  const handleSelectEvent = React.useCallback((evt, expandToTree = false) => {
    setSelectedEvent(evt);
    if (expandToTree && evt.path) {
      setViewMode("spotlight");
      setExpandedPaths(prev => {
        const next = new Set(prev);
        for (let i = 1; i <= evt.path.length; i++) {
          next.add(evt.path.slice(0, i).join("/"));
        }
        return next;
      });
      setTimeout(() => {
        if (activeTreeEventRef.current) {
          activeTreeEventRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 120);
    }
    // Seek to 5s before the event's timestamp (deferred so the player is
    // mounted when selecting from the empty state).
    const seconds = parseTimeToSeconds(evt.time);
    if (seconds > 0) setTimeout(() => seekToTime(Math.max(0, seconds - 5)), 150);
  }, [seekToTime]);

  // Keep the active row visible in the virtualized timeline.
  useEffect(() => {
    if (viewMode !== "timeline" || !selectedEvent || !timelineListRef.current) return;
    const idx = filteredTimeline.findIndex(
      (e) => e.str === selectedEvent.str && e.time === selectedEvent.time
    );
    if (idx >= 0) timelineListRef.current.scrollToItem(idx, "smart");
  }, [selectedEvent, viewMode, filteredTimeline]);

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{ height: "100%", minHeight: "70vh", position: "relative" }}
    >
      {loading && (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 30,
            gap: 1.5,
            backgroundColor: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(1px)",
          }}
        >
          <CircularProgress size={32} sx={{ color: "rgba(232, 108, 0, 1)" }} />
          <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff" }}>
            Loading events…
          </Typography>
        </Stack>
      )}
      {/* Left: Category Tree */}
      <Box
        ref={treeScrollRef}
        sx={{
          width: { xs: "100%", md: "340px" },
          minWidth: "300px",
          borderRight: { md: "1px solid var(--border-1)" },
          borderBottom: { xs: "1px solid var(--border-1)", md: "none" },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: { md: "100%" },
          maxHeight: { xs: "40vh", md: "none" },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            px: 2,
            py: 1,
            borderBottom: "1px solid var(--border-1)",
            backgroundColor: "var(--surface-1)",
            flexShrink: 0,
            zIndex: 10,
          }}
        >
          <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)" }}>
            {viewMode === "spotlight" ? "Explore Attributes" : "Timeline"}
          </Typography>
          <Stack direction="row" sx={{ backgroundColor: "var(--surface-2)", borderRadius: "6px", p: "2px" }}>
            <IconButton
              size="small"
              onClick={() => setViewMode("spotlight")}
              sx={{
                width: 28,
                height: 28,
                borderRadius: "5px",
                backgroundColor: viewMode === "spotlight" ? "var(--surface-1)" : "transparent",
                boxShadow: viewMode === "spotlight" ? "0 1px 2px rgba(0,0,0,0.1)" : "none",
                color: viewMode === "spotlight" ? "rgba(232, 108, 0, 1)" : "var(--text-2)",
              }}
            >
              <AccountTree sx={{ fontSize: 15 }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => setViewMode("timeline")}
              sx={{
                width: 28,
                height: 28,
                borderRadius: "5px",
                backgroundColor: viewMode === "timeline" ? "var(--surface-1)" : "transparent",
                boxShadow: viewMode === "timeline" ? "0 1px 2px rgba(0,0,0,0.1)" : "none",
                color: viewMode === "timeline" ? "rgba(232, 108, 0, 1)" : "var(--text-2)",
              }}
            >
              <ViewList sx={{ fontSize: 15 }} />
            </IconButton>
          </Stack>
        </Stack>

        <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid var(--border-1)", flexShrink: 0 }}>
          <TextField
            size="small"
            fullWidth
            placeholder={viewMode === "spotlight" ? "Search categories, players..." : "Search events..."}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined sx={{ fontSize: 16, color: "var(--text-2)" }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "8px",
                fontSize: "12px",
                height: 34,
                backgroundColor: "var(--surface-2)",
                "& fieldset": { borderColor: "var(--border-1)" },
                "&:hover fieldset": { borderColor: "var(--text-2)" },
              },
            }}
          />
        </Box>

        {/* Filters: team + set pieces */}
        <Stack
          direction="row"
          alignItems="center"
          gap={0.5}
          sx={{
            px: 1.5,
            py: 0.75,
            borderBottom: "1px solid var(--border-1)",
            flexShrink: 0,
            overflowX: "auto",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {[
            { key: "all", label: "All" },
            { key: "A", label: match?.team_a_details?.name || "Team A" },
            { key: "B", label: match?.team_b_details?.name || "Team B" },
          ].map((t) => {
            const active = teamFilter === t.key;
            const rgb = (TEAM_COLORS[t.key] || TEAM_COLORS.A).rgb;
            return (
              <Chip
                key={t.key}
                label={t.label}
                size="small"
                onClick={() => setTeamFilter(t.key)}
                sx={{
                  height: 24,
                  fontSize: "11px",
                  fontWeight: 600,
                  maxWidth: 120,
                  cursor: "pointer",
                  backgroundColor: active ? `rgba(${rgb}, 0.12)` : "var(--surface-2)",
                  color: active ? `rgba(${rgb}, 1)` : "var(--text-2)",
                  border: `1px solid ${active ? `rgba(${rgb}, 0.4)` : "var(--border-1)"}`,
                }}
              />
            );
          })}
          <Box sx={{ width: "1px", height: 16, backgroundColor: "var(--border-1)", mx: 0.5, flexShrink: 0 }} />
          <Chip
            label="Top Events"
            size="small"
            onClick={() => setTopEventsOnly((v) => !v)}
            sx={{
              height: 24,
              fontSize: "11px",
              fontWeight: 600,
              cursor: "pointer",
              flexShrink: 0,
              backgroundColor: topEventsOnly ? "rgba(232, 108, 0, 0.12)" : "var(--surface-2)",
              color: topEventsOnly ? "rgba(232, 108, 0, 1)" : "var(--text-2)",
              border: `1px solid ${topEventsOnly ? "rgba(232, 108, 0, 0.4)" : "var(--border-1)"}`,
            }}
          />
        </Stack>

        <Box ref={listBoxRef} sx={{ flex: 1, minHeight: 0, overflow: viewMode === "spotlight" ? "auto" : "hidden" }}>
          {viewMode === "spotlight" ? (
            <Box sx={{ p: 1 }}>
              {filteredTree.length === 0 ? (
                <Typography sx={{ fontSize: "12px", color: "var(--text-2)", textAlign: "center", py: 3 }}>
                  No results for "{searchQuery}"
                </Typography>
              ) : (
                filteredTree.map((cat, i) => (
                  <TreeNode
                    key={`${cat.label}-${i}`}
                    node={cat}
                    depth={0}
                    onSelectEvent={handleSelectEvent}
                    selectedEvent={selectedEvent}
                    expandedSet={expandedPaths}
                    onToggle={togglePath}
                    activeTreeEventRef={activeTreeEventRef}
                    teamAName={match?.team_a_details?.name || "Team A"}
                    teamBName={match?.team_b_details?.name || "Team B"}
                  />
                ))
              )}
            </Box>
          ) : filteredTimeline.length === 0 ? (
            <Typography sx={{ fontSize: "12px", color: "var(--text-2)", textAlign: "center", py: 3 }}>
              No results for "{searchQuery}"
            </Typography>
          ) : (
            <FixedSizeList
              ref={timelineListRef}
              height={listHeight}
              width="100%"
              itemCount={filteredTimeline.length}
              itemSize={TIMELINE_ROW_H}
              overscanCount={8}
              itemData={filteredTimeline}
              style={{ padding: 8 }}
            >
              {({ index, style, data }) => {
                const evt = data[index];
                const isActive = selectedEvent?.str === evt.str && selectedEvent?.time === evt.time;
                return (
                  <TimelineItem
                    style={style}
                    evt={evt}
                    isActive={isActive}
                    onClick={() => handleSelectEvent(evt)}
                    teamAName={match?.team_a_details?.name || "Team A"}
                    teamBName={match?.team_b_details?.name || "Team B"}
                  />
                );
              }}
            </FixedSizeList>
          )}
        </Box>
      </Box>

      {/* Right: Video Player + Event Details */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          overflow: "auto",
        }}
      >
        {/* Video Player */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#000",
            position: "relative",
            aspectRatio: "16/9",
            maxHeight: "450px",
          }}
        >
          {videoUrl ? (
            <ReactPlayer
              ref={playerRef}
              url={videoUrl}
              width="100%"
              height="100%"
              controls
              config={{
                file: {
                  attributes: {
                    controlsList: "nodownload",
                    disablePictureInPicture: true,
                    onContextMenu: (e) => e.preventDefault(),
                  },
                },
              }}

              // No event selected → start playback from 0 imperatively (no
              // controlled `playing` prop, to avoid the play/pause loop).
              onReady={() => {
                if (selectedEvent) return;
                const internal = playerRef.current?.getInternalPlayer?.();
                if (internal?.playVideo) internal.playVideo();
                else if (internal?.play) internal.play();
              }}
              style={{ position: "absolute", inset: 0 }}
            />
          ) : (
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                position: "absolute",
                inset: 0,
                gap: 1.5,
              }}
            >
              <SportsSoccer sx={{ fontSize: 48, color: "rgba(255,255,255,0.15)" }} />
              <Typography sx={{ fontSize: "14px", color: "rgba(255,255,255,0.4)" }}>
                Select an event from the tree to play the clip
              </Typography>
            </Stack>
          )}
        </Box>

        {/* Playback controls: skip + jump-to-timestamp */}
        {videoUrl && (
          <Stack
            direction="row"
            alignItems="center"
            gap={0.25}
            sx={{
              px: 1.5,
              py: 0.75,
              borderBottom: "1px solid var(--border-1)",
              backgroundColor: "var(--surface-1)",
              flexWrap: "wrap",
            }}
          >
            <IconButton size="small" title="Back 10s" onClick={() => skip(-10)} sx={{ color: "var(--text-2)" }}>
              <Replay10 sx={{ fontSize: 20 }} />
            </IconButton>
            <IconButton size="small" title="Back 5s" onClick={() => skip(-5)} sx={{ color: "var(--text-2)" }}>
              <Replay5 sx={{ fontSize: 20 }} />
            </IconButton>
            <IconButton size="small" title="Forward 5s" onClick={() => skip(5)} sx={{ color: "var(--text-2)" }}>
              <Forward5 sx={{ fontSize: 20 }} />
            </IconButton>
            <IconButton size="small" title="Forward 10s" onClick={() => skip(10)} sx={{ color: "var(--text-2)" }}>
              <Forward10 sx={{ fontSize: 20 }} />
            </IconButton>

            <Box sx={{ flex: 1 }} />

            <TextField
              size="small"
              placeholder="hh:mm:ss"
              value={jumpValue}
              onChange={(e) => setJumpValue(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && jumpToTimestamp()}
              InputProps={{
                sx: { fontSize: "12px", height: 32, width: 92, borderRadius: "8px", backgroundColor: "var(--surface-2)", "& fieldset": { borderColor: "var(--border-1)" } },
              }}
            />
            <Button
              size="small"
              onClick={jumpToTimestamp}
              sx={{ textTransform: "none", fontSize: "12px", fontWeight: 600, borderRadius: "8px", color: "rgba(232, 108, 0, 1)", minWidth: 0, px: 1.25 }}
            >
              Jump
            </Button>
          </Stack>
        )}

        {/* Event Details */}
        <Box sx={{ flex: 1 }}>
          {selectedEvent || matchStringEvents.length > 0 ? (
            <EventDetails event={selectedEvent} allEvents={matchStringEvents} onSelectEvent={handleSelectEvent} />
          ) : (
            <Stack alignItems="center" justifyContent="center" sx={{ py: 4, gap: 0.5 }}>
              <Typography sx={{ fontSize: "13px", color: "var(--text-2)" }}>No events</Typography>
              <Typography sx={{ fontSize: "11px", color: "var(--text-2)", opacity: 0.6 }}>Click a player event from the tree to view details</Typography>
            </Stack>
          )}
        </Box>
      </Box>
    </Stack>
  );
};

const parseFields = (str) => {
  const parts = str.split("-");
  return [
    { key: "Team", val: parts[0], color: "#3B82F6" },
    { key: "Jersey", val: parts[1], color: "#8B5CF6" },
    { key: "Action", val: parts[2], color: "#10B981" },
    { key: "Notation", val: parts[3], color: "#F59E0B" },
    { key: "Start", val: parts[4], color: "#EC4899" },
    { key: "End", val: parts[5], color: "#EC4899" },
    { key: "Time", val: parts[6], color: "#06B6D4" },
    { key: "Foot", val: parts[7], color: "#8B5CF6" },
    { key: "Special", val: parts[8], color: "#EF4444" },
    { key: "Half", val: parts[9], color: "#10B981" },
    { key: "Z-Keep", val: parts[10], color: "#6B7280" },
    { key: "Z-Ball", val: parts[11], color: "#6B7280" },
  ];
};

// Event → colour, keyed by event label (leaf) or eventId (0-4).
const colorMap = {
  0: "#E02424", 1: "#1C64F2", 2: "#0E9F6E", 3: "#FACA15", 4: "#16DBC2",
  Assist: "#FACA15", "Key Pass": "#0E9F6E", "Simple Pass": "#1C64F2", "Unsuccessful Pass": "#E02424",
  "Brilliant Shot": "#0E9F6E", Goal: "#FACA15", "Simple Shot": "#1C64F2", "Off Target": "#E02424",
  "Hit Goal Post": "violet", Successful: "#0E9F6E", Unsuccessful: "#E02424", Crucial: "#FACA15",
  "Ball Carry Short": "#FACA15", "Ball Carry Medium": "#1C64F2", "Ball Carry Long": "#0E9F6E",
  Handball: "#0E9F6E", Offside: "#1C64F2",
  "Interception Evaded": "#0E9F6E", "Intercepted-Simple": "#F97316", "Intercepted-Crucial": "#E02424",
  "Pressed Evaded": "#0E9F6E", "Pressed-Simple": "#F97316", "Pressed-Crucial": "#E02424",
  "Tackle Evaded": "#0E9F6E", "Tackled-Simple": "#F97316", "Tackled-Crucial": "#E02424",
  "Dribble Resisted": "#0E9F6E", "Dribbled Past-Simple": "#F97316", "Dribbled Past-Crucial": "#E02424",
  "Received Unsuccessful": "#E02424", "Received Simple Throw": "#0E9F6E", "Received Key Throw": "#1C64F2", "Received Assist Throw": "#FACA15",
  "Received Simple Pass": "#0E9F6E", "Received Key Pass": "#1C64F2", "Received Assist": "#FACA15",
  "Duel Won": "#0E9F6E", "Duel Lost": "#E02424",
  "Simple Header": "#1C64F2", "Brilliant Header": "#0E9F6E",
  "Simple Throw": "#1C64F2", "Key Throw": "#0E9F6E", "Assist Throw": "#FACA15",
};
const eventColor = (label, eventId, fallback = "rgba(232,108,0,1)") =>
  colorMap[label] ?? colorMap[Number(eventId)] ?? fallback;

const FootballFieldMap = ({ startZone, endZone, color }) => {
  const W = 260, H = 160;
  const padL = 18, padR = 18, padT = 12, padB = 20;
  const PW = W - padL - padR;
  const PH = H - padT - padB;
  const orange = color || "rgba(232,108,0,1)";
  // Single source of truth: arrowhead scales with the line stroke.
  const strokeW = 1.5;
  const arrowUnits = 4; // arrowhead length in stroke-width units (markerUnits="strokeWidth")
  const arrowLen = arrowUnits * strokeW; // px, used to pull the line back so the head sits on the end

  // Zones are a 2-digit RC code on a 10-col × 8-row grid:
  //   R = first digit (row, top→bottom), C = second digit (column).
  //   Columns run right→left in the raw code, so flip to left→right here:
  //   C 1 → rightmost … C 9 → leftmost; C 0 wraps to the leftmost of the prev row.
  const zoneToPos = (zone) => {
    if (zone == null || zone === "" || zone === "X") return null;
    const s = String(zone);
    const padded = s.length < 2 ? `0${s}` : s;
    const R = Number(padded[0]);
    const C = Number(padded[1]);
    if (Number.isNaN(R) || Number.isNaN(C)) return null;
    const colIdx = C === 0 ? 0 : 10 - C;
    const rowIdx = C === 0 ? R - 1 : R;
    return {
      x: padL + (colIdx + 0.5) * (PW / 10),
      y: padT + (rowIdx + 0.5) * (PH / 8),
    };
  };

  const s = zoneToPos(startZone);
  const e = zoneToPos(endZone);

  // Penalty arc geometry: arc centered on penalty spot, clipped to outside the penalty area
  const R = PH * 0.16;
  const yMid = padT + PH / 2;
  const xEdgeL = padL + PW * 0.157;
  const xEdgeR = padL + PW * (1 - 0.157);
  const dxArc = PW * (0.157 - 0.105);
  const dyArc = Math.sqrt(Math.max(0, R * R - dxArc * dxArc));

  let ax2 = null, ay2 = null;
  if (s && e) {
    const dx = e.x - s.x, dy = e.y - s.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist > 0) { ax2 = e.x - (dx / dist) * arrowLen; ay2 = e.y - (dy / dist) * arrowLen; }
  }

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="xMidYMid slice"
      style={{ width: "100%", height: "100%", display: "block" }}
    >
      <defs>
        <marker id="fmap-arrow" markerUnits="strokeWidth" markerWidth={arrowUnits} markerHeight={arrowUnits} refX={arrowUnits * 0.8} refY={arrowUnits / 2} orient="auto">
          <polygon points={`0 0, ${arrowUnits} ${arrowUnits / 2}, 0 ${arrowUnits}`} fill={orange} />
        </marker>
      </defs>

      {/* Full background — theme-aware */}
      <rect width={W} height={H} style={{ fill: "var(--surface-1)" }} />

      {/* Pitch surface */}
      <rect x={padL} y={padT} width={PW} height={PH} style={{ fill: "var(--surface-2)" }} />
      <rect x={padL} y={padT} width={PW} height={PH} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="1.2" />

      {/* Attack flow indicator */}
      <polygon
        points={`${padL + PW * 0.35},${padT + PH * 0.3} ${padL + PW * 0.6},${padT + PH * 0.3} ${padL + PW * 0.65},${padT + PH * 0.5} ${padL + PW * 0.6},${padT + PH * 0.7} ${padL + PW * 0.35},${padT + PH * 0.7}`}
        style={{ fill: "var(--border-1)", opacity: 0.25 }}
      />
      <text x={padL + PW * 0.5} y={padT + PH * 0.5 + 3} textAnchor="middle" style={{ fill: "var(--text-2)", fontSize: "7px", fontFamily: "sans-serif", opacity: 0.5 }}>Attack flow</text>

      {/* Center line & circle */}
      <line x1={padL + PW / 2} y1={padT} x2={padL + PW / 2} y2={padT + PH} style={{ stroke: "var(--border-1)" }} strokeWidth="1" />
      <circle cx={padL + PW / 2} cy={padT + PH / 2} r={PH * 0.16} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="1" />
      <circle cx={padL + PW / 2} cy={padT + PH / 2} r="1.5" style={{ fill: "var(--text-2)", opacity: 0.4 }} />

      {/* Left penalty area */}
      <rect x={padL} y={padT + PH * 0.2} width={PW * 0.157} height={PH * 0.6} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="1" />
      <rect x={padL} y={padT + PH * 0.35} width={PW * 0.055} height={PH * 0.3} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <rect x={padL - 5} y={padT + PH * 0.42} width="5" height={PH * 0.16} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <circle cx={padL + PW * 0.105} cy={padT + PH / 2} r="1.5" style={{ fill: "var(--text-2)", opacity: 0.4 }} />
      <path d={`M ${xEdgeL} ${yMid - dyArc} A ${R} ${R} 0 0 1 ${xEdgeL} ${yMid + dyArc}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />

      {/* Right penalty area */}
      <rect x={padL + PW * (1 - 0.157)} y={padT + PH * 0.2} width={PW * 0.157} height={PH * 0.6} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="1" />
      <rect x={padL + PW * (1 - 0.055)} y={padT + PH * 0.35} width={PW * 0.055} height={PH * 0.3} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <rect x={padL + PW} y={padT + PH * 0.42} width="5" height={PH * 0.16} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <circle cx={padL + PW * (1 - 0.105)} cy={padT + PH / 2} r="1.5" style={{ fill: "var(--text-2)", opacity: 0.4 }} />
      <path d={`M ${xEdgeR} ${yMid - dyArc} A ${R} ${R} 0 0 0 ${xEdgeR} ${yMid + dyArc}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />

      {/* Corner arcs */}
      <path d={`M ${padL} ${padT + 7} A 7 7 0 0 1 ${padL + 7} ${padT}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <path d={`M ${padL + PW - 7} ${padT} A 7 7 0 0 1 ${padL + PW} ${padT + 7}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <path d={`M ${padL + PW} ${padT + PH - 7} A 7 7 0 0 1 ${padL + PW - 7} ${padT + PH}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />
      <path d={`M ${padL + 7} ${padT + PH} A 7 7 0 0 1 ${padL} ${padT + PH - 7}`} fill="none" style={{ stroke: "var(--border-1)" }} strokeWidth="0.8" />

      {/* Movement arrow — orange */}
      {s && e && ax2 !== null && (
        <line x1={s.x} y1={s.y} x2={ax2} y2={ay2} stroke={orange} strokeWidth={strokeW} strokeLinecap="round" markerEnd="url(#fmap-arrow)" />
      )}

      {/* Start dot */}
      {s && <><circle cx={s.x} cy={s.y} r="5" fill={orange} opacity="0.2" /><circle cx={s.x} cy={s.y} r="2.5" fill={orange} /></>}

      {/* End dot */}
      {e && <><circle cx={e.x} cy={e.y} r="5" fill={orange} opacity="0.2" /><circle cx={e.x} cy={e.y} r="2.5" fill={orange} /></>}

      {/* Attack label */}
      <text x={padL + PW / 2} y={H - 4} textAnchor="middle" style={{ fill: "var(--text-2)", fontSize: "7px", fontFamily: "sans-serif", opacity: 0.4 }} letterSpacing="0.5">
        Attack →
      </text>
    </svg>
  );
};

const EventDetails = ({ event, allEvents, onSelectEvent }) => {
  const [copied, setCopied] = React.useState(false);
  const scrollRef = React.useRef(null);
  const activeRef = React.useRef(null);

  

  const handleCopy = (str) => {
    navigator.clipboard.writeText(str).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  React.useEffect(() => {
    if (activeRef.current && scrollRef.current) {
      activeRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [event]);

  const fields = event ? parseFields(event.str) : null;

  return (
    <Stack
      sx={{
        mx: 2,
        my: 1.5,
        borderRadius: "12px",
        border: "1px solid var(--border-1)",
        backgroundColor: "var(--surface-1)",
        overflow: "hidden",
      }}
    >
      {/* Header: attribute path + player + time */}
      {event && (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        sx={{ px: 2, py: 1, backgroundColor: "var(--surface-2)", borderBottom: "1px solid var(--border-1)", gap: 1 }}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          {event.path && (
            <Stack direction="row" alignItems="center" gap={0.5}>
              {event.path.map((seg, i) => (
                <React.Fragment key={i}>
                  <Typography sx={{ fontSize: "11px", fontWeight: i === event.path.length - 1 ? 700 : 500, color: i === event.path.length - 1 ? "rgba(232, 108, 0, 1)" : "var(--text-2)" }}>
                    {seg}
                  </Typography>
                  {i < event.path.length - 1 && (
                    <Typography sx={{ fontSize: "10px", color: "var(--text-2)", opacity: 0.5 }}>›</Typography>
                  )}
                </React.Fragment>
              ))}
            </Stack>
          )}
          <Chip label={`#${event.jersey} ${event.name}`} size="small" sx={{ height: 22, fontSize: "11px", fontWeight: 600, backgroundColor: "rgba(232, 108, 0, 0.12)", color: "rgba(232, 108, 0, 1)" }} />
          <Chip icon={<AccessTime sx={{ fontSize: "11px !important" }} />} label={event.time} size="small" sx={{ height: 22, fontSize: "11px", fontWeight: 600, backgroundColor: "var(--surface-1)", color: "var(--text-1)", border: "1px solid var(--border-1)", "& .MuiChip-icon": { color: "var(--text-2)" } }} />
          {/* {event.matchVideo && (
            <Chip label={`MV ${event.matchVideo}`} size="small" sx={{ height: 22, fontSize: "11px", fontWeight: 600, backgroundColor: "var(--surface-1)", color: "var(--text-2)", border: "1px solid var(--border-1)" }} />
          )} */}
        </Stack>
      </Stack>
      )}

      {/* Scrollable event strings list + Field Map */}
      <Stack
        direction="row"
        alignItems="stretch"
        sx={{ borderBottom: "1px solid var(--border-1)" }}
      >
        {/* Events list */}
        <Stack direction="row" alignItems="stretch" sx={{ flex: "1 1 0", minWidth: 0 }}>
          <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "var(--text-2)", whiteSpace: "nowrap", px: 1.5, py: 1, borderRight: "1px solid var(--border-1)", display: "flex", alignItems: "center" }}>
            Events
          </Typography>
          <Box
            ref={scrollRef}
            sx={{
              flex: 1,
              maxHeight: "120px",
              overflowY: "auto",
              "&::-webkit-scrollbar": { width: 4 },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "var(--border-1)", borderRadius: 2 },
            }}
          >
            {allEvents.map((evt, i) => {
              const isActive = !!event && evt.str === event.str && evt.time === event.time;
              return (
                <Stack
                  key={`${evt.str}-${i}`}
                  ref={isActive ? activeRef : undefined}
                  direction="row"
                  alignItems="center"
                  onClick={() => onSelectEvent(evt, true)}
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    gap: 1,
                    cursor: "pointer",
                    backgroundColor: isActive ? "rgba(232, 108, 0, 0.08)" : "transparent",
                    borderLeft: isActive ? "3px solid rgba(232, 108, 0, 1)" : "3px solid transparent",
                    "&:hover": { backgroundColor: isActive ? "rgba(232, 108, 0, 0.12)" : "var(--surface-2)" },
                    transition: "background-color 0.1s",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 1,
                      fontFamily: "monospace",
                      fontSize: "11px",
                      fontWeight: isActive ? 700 : 400,
                      color: isActive ? "var(--text-1)" : "var(--text-2)",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {evt.str}
                  </Typography>
                  <Stack sx={{ alignItems: "flex-end" }}>
                    <Typography sx={{ fontSize: "10px", color: "var(--text-2)", opacity: 0.6, whiteSpace: "nowrap" }}>
                      {evt.time}
                    </Typography>
                    {/* {evt.matchVideo && (
                      <Typography sx={{ fontSize: "9px", color: "var(--text-2)", opacity: 0.5, whiteSpace: "nowrap" }}>
                        MV {evt.matchVideo}
                      </Typography>
                    )} */}
                  </Stack>
                </Stack>
              );
            })}
          </Box>
          <IconButton
            size="small"
            disabled={!event}
            onClick={() => event && handleCopy(event.str)}
            title="Copy selected event string"
            sx={{
              width: 36,
              borderLeft: "1px solid var(--border-1)",
              borderRadius: 0,
              color: copied ? "#10B981" : "var(--text-2)",
              backgroundColor: copied ? "rgba(16, 185, 129, 0.06)" : "transparent",
              "&:hover": { backgroundColor: "var(--surface-2)" },
            }}
          >
            {copied ? <Check sx={{ fontSize: 14 }} /> : <ContentCopy sx={{ fontSize: 14 }} />}
          </IconButton>
        </Stack>

        {/* Field Map */}
        {event && (
          <Box
            sx={{
              width: "220px",
              flexShrink: 0,
              borderLeft: "1px solid var(--border-1)",
              backgroundColor: "var(--surface-1)",
              overflow: "hidden",
              alignSelf: "stretch",
            }}
          >
            <FootballFieldMap
              startZone={fields[4].val}
              endZone={fields[5].val}
              color={eventColor(event.path?.[event.path.length - 1], fields[3].val)}
            />
          </Box>
        )}
      </Stack>

      {/* Parsed fields for selected event */}
      {event && (
      <Stack direction="row" flexWrap="wrap" gap={0.5} alignItems="center" sx={{ px: 2, py: 1.5 }}>
        {fields.map((f, i) => {
          const isX = f.val === "X";
          return (
            <React.Fragment key={f.key}>
              <Box
                title={f.key}
                sx={{
                  display: "inline-flex",
                  flexDirection: "column",
                  alignItems: "center",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                  backgroundColor: isX ? "transparent" : `${f.color}10`,
                  border: `1px solid ${isX ? "var(--border-1)" : `${f.color}30`}`,
                  minWidth: 40,
                }}
              >
                <Typography sx={{ fontSize: "9px", fontWeight: 600, color: isX ? "var(--text-2)" : f.color, lineHeight: 1, mb: "2px", opacity: isX ? 0.5 : 0.8 }}>
                  {f.key}
                </Typography>
                <Typography sx={{ fontSize: "13px", fontWeight: 700, color: isX ? "var(--text-2)" : "var(--text-1)", lineHeight: 1, fontFamily: "monospace", opacity: isX ? 0.4 : 1 }}>
                  {f.val || "—"}
                </Typography>
              </Box>
              {i < fields.length - 1 && (
                <Typography sx={{ fontSize: "11px", color: "var(--border-1)", fontWeight: 300, mx: -0.25 }}>–</Typography>
              )}
            </React.Fragment>
          );
        })}
      </Stack>
      )}
    </Stack>
  );
};

export default Spotlight;
